import { render, staticRenderFns } from "./purchaseRemits.vue?vue&type=template&id=3af53dc8&scoped=true"
import script from "./purchaseRemits.vue?vue&type=script&lang=js"
export * from "./purchaseRemits.vue?vue&type=script&lang=js"
import style0 from "./purchaseRemits.vue?vue&type=style&index=0&id=3af53dc8&prod&lang=css"
import style1 from "./purchaseRemits.vue?vue&type=style&index=1&id=3af53dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af53dc8",
  null
  
)

export default component.exports